<template>
    <div>
        <div class="header pb-2 d-flex align-items-center bg-features">
            <div class="container align-items-center mt-9 mb-4">
                <div class="row mb-5">
                    <div class="col">
                        <h1 class="display-1 text-white mt-0 mb-5 text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Функции
                        </h1>
                        <h1 class="text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Область использования сервиса довольно обширная, это могут быть личные p2p сообщения содержащие
                            конфиденциальные данные, общение сотрудников внутри компании. Общение с банками, юридическими и
                            государственными конторами и т.д.
                        </h1>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <div class="container mt-6 mb-6">
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Конфиденциальность и безопасность</h1>
                    <p>
                        Современное сквозное шифрование обеспечивает безопасность всех ваших разговоров.
                    </p>
                    <p>
                        Командор защищает конфиденциальные данные таким образом, что только вы и человек с которым вы общаетесь, может прочитать содержимое, а никто другой, даже Командор.
                    </p>
                    <p>
                        Сквозное шифрование означает, что у Командор и третьих лиц нет к ним доступа.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Электронная подпись</h1>
                    <p>
                        Подписывайте любые файлы вашей электронной подписью перед отправкой.
                    </p>
                    <p>
                        Добавьте свою подпись к любому входящему сообщению и оно автоматически будет переслано отправителю.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Обмен любыми документами</h1>
                    <p>
                        Оправляйте PDF-файлы, документы Word и Excel, фотографии, видео и многое другое, не используя
                        приложения для передачи файлов или электронную почту.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Избранное и папки для сохранения сообщений</h1>
                    <p>
                        Сохраняйте важные сообщений в специальном чате «Избранное» или добавляйте их в личные папки.
                        Вы можете создать неограниченное количество папок для удобного хранения важных сообщений.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Облако, синхронизация на все устройства</h1>
                    <p>
                        Все ваши сообщения и файлы хранятся в надежном облачном дата центре на территории России и
                        синхронизируются между всеми вашими устройствами.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">Доверенные контакты и чаты</h1>
                    <p>
                        Контакты и чаты являются доверенными т.к. все пользователи мессенджера Командор имеют
                        действующий квалифицированный или не квалифицированный сертификат электронной подписи.
                    </p>
                    <p>
                        Сертификаты постоянно проверяются на действительность тем самым делая ваши контакты и
                        чаты - доверенными.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
        </div>

    </div>
</template>
<script>
  export default {
    data () {
      return {
        // color: 'rgb(255,255,255, 1)'
        color: '#ced4da'
      }
    },
  };
</script>
<style>
    .bg-features {
        background-image: url(/img/bg-features.jpg);
        background-size: cover;
        background-position: center top;
        min-height: 525px;
    }
</style>
